document.addEventListener("product:page:loaded", function () {
  const params = new URL(document.location).searchParams;
  const value = params.get("variant");
  const pro = window.__pdpConfig && window.__pdpConfig.productJSON;

  if (pro && params.has("variant")) {
    for (var i = 0; i < pro.variants.length; i++) {
      if (pro.variants[i]['id'] == value) {
        document.dispatchEvent(new CustomEvent("custom:variant:changed", {
          detail: { variant: pro.variants[i] }
        }));
        break;
      }
    }
  }
}, { once: true });

document.addEventListener("custom:variant:changed", function (evt) {
  var curtVariantId = evt.detail.variant;

  if (!curtVariantId) return;

  var result_preorder = preOrderVariants.filter(function (id) { return id[0] == curtVariantId.id; });
  var add_to_cart_btn = document.querySelector('button[name="add"].product-form__submit');
  var notify_me_btn = document.querySelector('.notify-me-btn.product-form__submit');
  var pre_order_btn = document.querySelector('#preorder-text');
  var productForm = document.querySelector('.product-form__buttons .btn-trigger-event');
  var stocked_out_btn = document.querySelector('button[name="add"].product-form__submit.stocked-out');
  var pdpBuyNowBtn = document.querySelector('.but-btn-container [data-pdp-buy-now]');

  if (result_preorder.length > 0) {
    var cur_array = result_preorder[0];
    var text = 'Dispatch Starts on ' + cur_array[1];

    if (cur_array[1] != '' && curtVariantId.available) {
      add_to_cart_btn.querySelector('span').textContent = 'Add to cart';
      productForm.classList.remove('scroll_to_size');
      pre_order_btn.textContent = text;
      add_to_cart_btn.style.display = 'none';
      if (notify_me_btn) notify_me_btn.style.display = 'none';
      if (stocked_out_btn) stocked_out_btn.style.display = 'none';
      pre_order_btn.style.display = 'block';
      if (pdpBuyNowBtn) pdpBuyNowBtn.style.display = 'none';
      document.querySelectorAll('.quick-size-warning').forEach(function (el) {
        el.style.display = 'flex';
      });
    } else if (cur_array[1] == '' && curtVariantId.available) {
      add_to_cart_btn.removeAttribute('disabled');
      add_to_cart_btn.querySelector('span').textContent = window.variantStrings.addToCart;
      if (productForm.classList.contains('scroll_to_size')) {
        productForm.classList.remove('scroll_to_size');
      }
      pre_order_btn.textContent = '';
      pre_order_btn.style.display = 'none';
      if (notify_me_btn) notify_me_btn.style.display = 'none';
      if (stocked_out_btn) stocked_out_btn.style.display = 'none';
      add_to_cart_btn.style.display = 'block';
      if (pdpBuyNowBtn) { pdpBuyNowBtn.style.display = ''; pdpBuyNowBtn.disabled = false; }
    } else if (!curtVariantId.available) {
      pre_order_btn.style.display = 'none';
      add_to_cart_btn.style.display = '';
      add_to_cart_btn.disabled = false;
      if (notify_me_btn) notify_me_btn.style.display = 'none';
      if (stocked_out_btn) stocked_out_btn.style.display = 'none';
      if (pdpBuyNowBtn) { pdpBuyNowBtn.style.display = ''; pdpBuyNowBtn.disabled = true; }
    }
  }
}, false);
